
import { Login } from './login';
import { BehaviorsIntpages } from './behaviors-intpages';
// import {PlayerOfferTracker} from './player-offer-tracker';
import { Search } from '../../apps/root/assets/js/search-games';
import { Balance } from '../../apps/root/assets/js/balance';
import { LuckyShot } from '../../apps/root/assets/js/luckyshot';
import { JackpotCounter } from '../../apps/root/assets/js/jackpot-counter';
import { Notifications } from "../../apps/root/assets/js/notifications";
import {Mousemove} from "../../apps/root/assets/js/mousemove";
// get URL path, params
const pathname = window.location.pathname;
const urlParams = new URLSearchParams(window.location.search);
// set auth status
Login.setAuthStatus().then(r => {});
Mousemove.init();
/*------------------------ TOGGLE QUICK DEPOSIT --------------------- */
// let depositBtn = document.getElementById("quick-dep-button");
// let quickdepositForm = document.querySelector(".promos__card-quickdeposit");
// let quickdeposit = document.querySelector(".quickdeposit");
// const quickdepositInner = document.querySelector('.quickdeposit-inner');
// let BtnHamMenu = document.getElementById("BtnHamMenu");
// let ConMenuLeft = document.getElementById("ConMenuLeft");
// let Wrapper = document.getElementById("Wrapper");
// const quick_deposit_open = document.querySelectorAll('[data-toggle="quick_deposit"]');

// quickdepositForm ? quickdepositForm.classList.remove("hidden") : quickdepositForm
// quickdepositForm ? quickdepositForm.classList.add("display-block") : quickdepositForm
// quickdeposit ? quickdeposit.classList.add("hidden") : quickdeposit

// //mobile bottom menu button
// if(quick_deposit_open[1]) {
//   quick_deposit_open[1].addEventListener('click', () => {
//     depositBtn.innerText = "CLOSE"
//     quickdeposit.classList.remove("hidden");
//   });
// }

// if (window.location.href.includes("?deposit")) {
//   depositBtn.innerText = "CLOSE"
//   quickdeposit.classList.remove("hidden")
//   quickdeposit.classList.add("display-block")
//   quickdeposit.style.height = "100%"
//   window.scrollTo(0, 0);
// }

// // quickdeposit.classList.add("hidden");

// if (depositBtn && quickdeposit) {
//   depositBtn.addEventListener('click', (e) => {

//     if (depositBtn.innerText == "CLOSE") {
//       depositBtn.innerText = "DEPOSIT"
//       quickdeposit.classList.remove("display-block")
//       quickdeposit.classList.add("hidden")

//     } else {
//       //scroll to top on deposit press
//       window.scrollTo(0, 0);

//       depositBtn.innerText = "CLOSE"
//       quickdeposit.classList.remove("hidden")
//       quickdeposit.classList.add("display-block")
//       quickdeposit.style.height = "100%"


//       //closing the menu mobile devices on pressing deposit button 
//       BtnHamMenu ? BtnHamMenu.classList.remove("Cross") : BtnHamMenu
//       ConMenuLeft ? ConMenuLeft.classList.remove("Opened") : ConMenuLeft
//       Wrapper ? Wrapper.classList.remove("Blur") : Wrapper


//     }

//   })
//   /*------------------------ CLOSE POPUP QUICK DEPOSIT ON CLICK ANYWHERE AROUND FORM --------------------- */
//   quickdeposit.addEventListener('click', (e) => {
//     if (e.target == quickdeposit || e.target == quickdepositInner) {
//       depositBtn.innerText = "DEPOSIT"
//       quickdeposit.classList.remove("display-block")
//       quickdeposit.classList.add("hidden")
//     }
//   })
// }


/*------------------------ TRANSLATION --------------------- */

document.addEventListener("DOMContentLoaded", () => {

  /*----------------------- COOKIE ----------------------*/
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  const btnCloseCookiePopup = document.querySelector('#CookieClose') || null;
  if (btnCloseCookiePopup) {
    btnCloseCookiePopup.addEventListener('click', () => {
      document.querySelector('#CookiePopup').style.display = 'none';
      setCookie('acceptedCookies', '1', 30);
    });
  }

  /*----------------------- LOGIN -----------------------*/
  if (urlParams.has('login')) Login.triggerControl(); // show login if requested in the URL
  const triggersLogin = Login.getTriggers();
  triggersLogin.forEach((btn) => btn.addEventListener('click', (e) => Login.triggerControl(e, btn)));

  /*----------------------- SPECIAL OFFERS -----------------------*/
  // PlayerOfferTracker.init(Login);


  /*----------------------- SEARCH -----------------------*/
  const searchModal = Search.getModal();
  const triggersSearch = Search.getTriggers();
  const inputField = Search.getInputField(searchModal);
  const clearInputBtn = Search.getClearInputBtn();
  Search.preventSubmit();
  // set triggers which open modal
  if (triggersSearch.length > 0) {
    triggersSearch.forEach((btn) => btn.addEventListener('click', () => Search.toggleModal()));
  }

  // set listener on search input field
  if (inputField) {
    inputField.addEventListener('input', (e) => Search.begin(e));
  }

  // set listener on clear input field
  if (inputField && clearInputBtn) {
    clearInputBtn.addEventListener('click', () => Search.clearInput());
  }


  /*----------------------- NOTIFICATIONS -----------------------*/
  const triggersNotifications = Notifications.getTriggers();
  if (triggersNotifications.length > 0) {
    triggersNotifications.forEach((btn) => btn.addEventListener('click', () => Notifications.toggleModal()));
  }


  /*----------------- BEHAVIORS INTPAGES ------------------*/
  BehaviorsIntpages.init();

  /*----------------------- BALANCE -----------------------*/
  if (Balance.button) {
    document.addEventListener('click', (event) => {
      const button = document.getElementById('toggle_balance');
      const dropdown = document.getElementById('player_balance');

      if (event.target === dropdown || dropdown.contains(event.target)) {
        event.stopPropagation();
        return;
      }

      if (event.target === button || button.contains(event.target)) {
        Balance.toggleDropdown();
        return;
      }

      if ((event.target === !button || !button.contains(event.target)) && button.classList.contains('open')) {
        Balance.toggleDropdown();
        return;
      }
    })
  }

  /*----------------------- JACKPOT COUNTER -----------------------*/
  JackpotCounter.init();

  /*----------------------- LUCKY SHOT -----------------------*/
  const luckyshotbtn = LuckyShot.trigger;
  if (luckyshotbtn) luckyshotbtn.addEventListener('click', () => LuckyShot.init());
  if (urlParams.has('luckyshot')) LuckyShot.init();

  /*----------------------- MENU LEFT -----------------------*/
  const menuNav = document.querySelector('#MenuNav');
  const listElements = Array.from(menuNav.querySelectorAll('li'));

  listElements.forEach((listItem) => {
    const header = listItem.querySelector('.titleContainer');
    const content = listItem.querySelector('.ItemsContainer');

    if (content && header.closest('.isCollapsible')) {
      const arrowImg = header.querySelector('.arrow-img');

      arrowImg.addEventListener('click', (event) => {
        event.preventDefault();
        listItem.classList.toggle('open');
        content.classList.toggle('open');

        if (arrowImg.classList.contains('open')) {
          arrowImg.classList.remove('open');
        } else {
          arrowImg.classList.add('open');
        }
      });
    }
  })

});

/*----------------------- LANGUAGE SWITCH -----------------------*/
const lang_switch = document.querySelector('.lang_switch');
if (lang_switch) {

  document.addEventListener('click', (e) => {
    const target = e.target;
    if ((!target.closest('.lang_switch') && lang_switch.classList.contains('open'))) {
      lang_switch.classList.remove('open');
    } else {
      if ((target.matches('.lang_item.active'))) {
        lang_switch.classList.contains('open') ? lang_switch.classList.remove('open') : lang_switch.classList.add('open');
      }
    }
  });

}